import { render, staticRenderFns } from "./InformationQuickView.vue?vue&type=template&id=ca0f6cd6&scoped=true&lang=html"
import script from "./InformationQuickView.vue?vue&type=script&lang=js"
export * from "./InformationQuickView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0f6cd6",
  null
  
)

export default component.exports